import React from 'react';
import { UbicacionDescrita } from '../../lib/ubicaciones';

// Chips de solo lectura con la ubicación de un producto (oculto tras
// ubicacionesHabilitadas). "Sin ubicación" si no está en ninguna zona.
export default function UbicacionChips({ ubicaciones, vacio = 'Sin ubicación' }: { ubicaciones: UbicacionDescrita[] | undefined; vacio?: string }) {
  if (!ubicaciones) return null;
  const base: React.CSSProperties = {
    display: 'inline-block', fontSize: 11, lineHeight: '16px', padding: '1px 7px', borderRadius: 6,
    border: '1px solid rgba(59,130,246,0.3)', background: 'rgba(59,130,246,0.1)', color: '#93c5fd', whiteSpace: 'nowrap',
  };
  if (ubicaciones.length === 0) {
    return <span style={{ ...base, border: '1px solid #334155', background: 'transparent', color: '#64748b' }}>{vacio}</span>;
  }
  return (
    <span style={{ display: 'inline-flex', flexWrap: 'wrap', gap: 4 }}>
      {ubicaciones.map((u, i) => (
        <span key={`${u.zonaId}-${u.codigo ?? 'zona'}-${i}`} style={u.codigo ? base : { ...base, color: '#94a3b8', borderColor: '#334155', background: 'transparent' }} title={u.etiqueta}>
          {u.etiqueta}
        </span>
      ))}
    </span>
  );
}
